import {
  Radio,
  Stack,
  TextField,
  FormLabel,
  RadioGroup,
  FormControl,
  FormControlLabel
} from "@material-ui/core";
import { evictionType as evictionTypes } from "../../../../../@types/sharedSchema";
import { useTranslation } from "react-i18next";
import { EditableListing } from "../../../../../@types/listings/new";
import type { ChangeEvent } from "react";

type ListingDialogInputEvictionProps = {
  loading: boolean;
  editableFormColumns: EditableListing;
  handleChange: ({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => void;
};

export function ListingDialogInputEviction({
  loading,
  editableFormColumns,
  handleChange
}: ListingDialogInputEvictionProps): JSX.Element {
  const { evictionType, evictionDate, listingState } = editableFormColumns;

  const { t: translate } = useTranslation();

  const evictionDateLabelKey = listingState === "newConstruction" ? "deliveryDate" : "evictionDate";
  const evictionDateLabel = translate(`listingsPage.tableColumns.${evictionDateLabelKey}`);

  const evictionDateHidden = !["immediate", "flexible"].includes(evictionType);

  return (
    <Stack direction={{ xs: "column", md: "row" }} gap={2}>
      <FormControl fullWidth>
        <FormLabel sx={{ color: "black !important" }}>
          {translate("listingsPage.tableColumns.evictionType")}
        </FormLabel>
        <RadioGroup row>
          {evictionTypes.map((type) => (
            <FormControlLabel
              key={type}
              value={type}
              control={
                <Radio
                  name="evictionType"
                  checked={evictionType === type}
                  disabled={loading}
                  onChange={handleChange}
                />
              }
              label={translate(`listingsPage.evictionTypeLabel.${type}`)}
            />
          ))}
        </RadioGroup>
      </FormControl>
      {evictionDateHidden && (
        <TextField
          fullWidth
          type="date"
          name="evictionDate"
          value={evictionDate}
          label={evictionDateLabel}
          disabled={loading}
          InputLabelProps={{ shrink: true }}
          onChange={handleChange}
        />
      )}
    </Stack>
  );
}
